import {
    hostUrlHelper,
    locHrefUtil,
    SALES_CHECKIN_APP_PREFIX,
    environmentNameUtils,
    apiConfigHelper
} from '@makemydeal/dr-shared-ui-utils';
import type { HostEnvironment } from '@makemydeal/dr-shared-ui-utils';
import { toLower } from 'lodash';

export const getEnv = () => {
    const env = hostUrlHelper.getHostUrlEnvironment(SALES_CHECKIN_APP_PREFIX, locHrefUtil.getLocHref());
    const resolved = environmentNameUtils.getEnvironmentName(env);
    // If environment name utility returns null/undefined, default to 'local' (make fallback observable for coverage)
    return resolved ? toLower(resolved) : 'local';
};

export const getSalesCheckinBffEndPoint = (endPoint: string, environment?: HostEnvironment) => {
    if (environment) {
        const builder = apiConfigHelper.apiUrlBuilderFromEnvironment(environment, SALES_CHECKIN_APP_PREFIX);
        return builder.buildBffApiUrl(`/${endPoint}`).url;
    }
    const locHref = locHrefUtil.getLocHref();
    return apiConfigHelper.buildBffApiUrl(SALES_CHECKIN_APP_PREFIX, locHref, endPoint).url;
};
